module.exports = __webpack_public_path__ + "5e964eed804a66d98980a1264226e010.png";